import { useState } from 'react';

import { Widget } from '../blog/Figure';

/**
 * Tick what is true of your setup and see whether a proxy alone is enough, for
 * /blog/mcp-proxy-vs-mcp-gateway. Each situation maps to the one thing a
 * proxy would have to grow to cover it, using the four gaps the post walks
 * through. Nothing is scored or stored; it just lists what the ticks add up to.
 */

const SITUATIONS: { id: string; label: string; needs: string }[] = [
  {
    id: 'write',
    label: 'A server I use has a tool that writes or deletes',
    needs: 'A rule that allows one tool and denies another',
  },
  {
    id: 'shared',
    label: 'More than one agent or person shares a server',
    needs: 'An identity per caller, so a rule can name one',
  },
  {
    id: 'who',
    label: 'I need to know which agent made a call',
    needs: 'A log written by something that knows the caller',
  },
  {
    id: 'key',
    label: 'The API key must stay out of agent configs',
    needs: 'A place that holds the key and injects it',
  },
  {
    id: 'review',
    label: 'A security review will ask for a record of refusals',
    needs: 'Refused calls written down, not only allowed ones',
  },
];

export function ProxyOrGateway() {
  const [picked, setPicked] = useState<string[]>([]);
  const toggle = (id: string) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  const open = SITUATIONS.filter((s) => picked.includes(s.id));

  return (
    <Widget title="Is a proxy enough for your setup?">
      <div className="bw-in bw-cols">
        <fieldset className="gc-needs">
          <legend className="bw-note">Tick what is true</legend>
          {SITUATIONS.map((s) => (
            <label key={s.id}>
              <input type="checkbox" checked={picked.includes(s.id)} onChange={() => toggle(s.id)} />
              <span>{s.label}</span>
            </label>
          ))}
        </fieldset>
        <div aria-live="polite">
          <p className="bw-note">
            {open.length === 0
              ? 'Nothing ticked: a pass-through proxy covers a single agent talking to a server that only reads.'
              : `A pass-through proxy leaves ${open.length} of 5 open. It would need:`}
          </p>
          <ul className="pl-needs">
            {open.map((s) => (
              <li key={s.id}>{s.needs}</li>
            ))}
          </ul>
        </div>
      </div>
    </Widget>
  );
}
